import type { EntitySummary } from '../summary';
import type { GameEvent } from '../types';
import type { DiffContext } from './context';

/**
 * An own unit that stopped where it was sent. Automated units come and go
 * constantly: only orders the player gave are reported, and not a promoted
 * unit stepping out of a building that no longer takes it.
 */
export function unitArrived(
  c: DiffContext,
  u: EntitySummary,
  before: EntitySummary
): GameEvent | null {
  if (!before.moving || u.moving || u.auto || before.stepOut) return null;
  return { kind: 'arrival', text: `${c.unitName(u.type)} arrived`, pos: u.pos };
}
